import { useState } from "react"
import { Typography, Paper, IconButton, Collapse, Link } from "@mui/material"
import ArrowRightIcon from "../../../../assets/icons/ArrowRight"
import { useTranslationLabel } from "../../../../hooks/useTranslationLabel"
import { Driver } from "../../../../types/driverTypes"
import { useTranslation } from "react-i18next"

type DriverProps = {
  driver: Driver,
  showDisconectBtn?: boolean,
  handleAddDisconectDriver?: (driver: Driver) => void
}

const mapStatusToTranslationKey = (status: string) => {
  const statusMap: any = {
    Activo: "active",
    Inactivo: "inactive",
    "Problema de cuenta": "account_problem",
    Pendiente: "pending",
  }

  return statusMap[status] || status
}

const DriverItem = ({ driver, showDisconectBtn, handleAddDisconectDriver }: DriverProps) => {
  const { INPUT_EMAIL, INPUT_PHONE, DISCONNECT_DRIVER } = useTranslationLabel()
  const [expanded, setExpanded] = useState(false)
  const { t } = useTranslation()
  const translatedDriverStatus = t(
    mapStatusToTranslationKey(driver.driverStatus),
  )

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <Paper className="driver-item" elevation={3}>
      <div className="driver-summary" onClick={handleExpandClick}>
        <Typography variant="subtitle1" className="driver-name">
          {driver.firstName + " " + driver.lastName}
        </Typography>
        <div className="flex center">
          <Typography variant="subtitle1" className="driver-name">
            {translatedDriverStatus}
          </Typography>

          <IconButton>
            <ArrowRightIcon className={expanded ? "rotate-arrow" : "icon-driver-summary"} />
          </IconButton>
        </div>
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className="driver-details">
          <Typography variant="body1">
            {INPUT_PHONE}: {driver.phoneNumber}
          </Typography>
          <Typography variant="body1">
            {INPUT_EMAIL}: {driver.email}
          </Typography>
          {showDisconectBtn && (
            <Link variant="body1" onClick={() => {handleAddDisconectDriver && handleAddDisconectDriver(driver)}}>
              {/* {driver.driverStatusId === 2 ? DISCONNECT_DRIVER:"Active back"} */}
              {DISCONNECT_DRIVER}
            </Link>
          )}
        </div>
      </Collapse>
    </Paper>
  )
}
export default DriverItem
